<div class="paywall">
  <button class="paywall__close" type="button" (click)="close()" aria-label="Закрыть">
    <i class="icon-close"></i>
  </button>

  <ng-container [ngSwitch]="step">

    <ng-container *ngSwitchCase="'intro'">
      <div class="paywall__intro">
        <img class="paywall__illus"
             src="/assets/img/payment/paywall-illustration.svg"
             alt=""
             width="168"
             height="168">

        <div class="paywall__intro-body">
          <div class="paywall__intro-text">
            <h2 class="paywall__title">
              <ng-container *ngIf="data.upsell.type === 'upgrade'">Превышен лимит пользователей</ng-container>
              <ng-container *ngIf="data.upsell.type === 'expansion'">Докупите места для новых участников</ng-container>
            </h2>
            <p class="paywall__desc">
              <ng-container *ngIf="data.upsell.type === 'upgrade'">
                На бесплатном тарифе доступно только
                <strong>{{ data.limit }}</strong> {{ seatsWord }} для участников, перейдите на Premium тариф, чтобы увеличить.
              </ng-container>
              <ng-container *ngIf="data.upsell.type === 'expansion'">
                Активных участников: <strong>{{ data.used }}</strong> из <strong>{{ data.limit }}</strong>.
                Для добавления новых участников докупите места.
              </ng-container>
            </p>
          </div>

          <button type="button" class="paywall__cta" (click)="onProceed()">
            <ng-container *ngIf="data.upsell.type === 'upgrade'">Все возможности Premium тарифа</ng-container>
            <ng-container *ngIf="data.upsell.type === 'expansion'">Докупить места</ng-container>
          </button>
        </div>
      </div>
    </ng-container>

    <div *ngSwitchCase="'method'" class="paywall__method">
      <h3 class="paywall__method-title">Выберите способ оплаты</h3>
      <payment-method-choice (chosen)="onMethodChosen($event)"></payment-method-choice>
    </div>

    <tariff-expansion-builder
      *ngSwitchCase="'expansion'"
      [payload]="data"
      [paymentType]="selectedMethod || 'bank_card'"
      (created)="onComplete($event)">
    </tariff-expansion-builder>

  </ng-container>
</div>
